export const START_BULK_LOADING = 'START_BULK_LOADING';

export const startBulkLoading = () => ({
    type: START_BULK_LOADING
});